export const SESSION_KEY = 'payment_token'
